import React from 'react';
import { useFormContext } from 'react-hook-form';
import { AutocompleteField } from 'components/form';

import { DealSheetRulesFilters } from './index';
import { BizOrIndividual } from '@trnsact/trnsact-shared-types';

export const CustomerType = () => {
  const { control } = useFormContext<DealSheetRulesFilters>();

  return (
    <AutocompleteField
      multiple
      size="small"
      control={control}
      name="CUSTOMER_TYPE"
      disableCloseOnSelect
      textFieldProps={{ variant: 'outlined', label: 'Customer Type' }}
      options={[
        { label: 'Individual', value: BizOrIndividual.Individual },
        { label: 'Business', value: BizOrIndividual.Business },
      ]}
    />
  );
};
